import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=5d1eb50b&scoped=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=5d1eb50b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1eb50b",
  null
  
)

export default component.exports